import React, {useEffect, useContext, useState} from 'react';

import {
  Modal,
  Form,
  Dimmer,
  Loader,
  Dropdown,
  ModalHeader,
  ModalActions,
  Progress,
  Button,
  FormInput,
  TextArea,
} from 'semantic-ui-react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ContactInput from '../../components/ContactInput';
import { parsePhoneNumber } from 'react-phone-number-input';

import { sendInvite } from '../../../services/Invite';
import { toast } from 'react-toastify';
import './style.less'


const InboundCallingEnableModal = ({isModalOpen, progress, error, close}) => {

  return (
    <Modal open={isModalOpen} onClose={()=> {close()}} size={'tiny'} className="invite-modal-root" closeIcon>
      <ModalHeader>
        <h5>
          Enabling inbound calling feature. 
        </h5>
      </ModalHeader>

        <Modal.Content className="fnf-invite-modal-content">

          <div className="inbound-progress">
          <Progress
            percent={progress}
            className="inbound-progress"
            size="tiny"
            autoSuccess
            color="blue"
            style={{ width: '30%', marginBottom: '0px' }}
          />
          <div>
            {error? <div>
              {error}
              </div>:<></>}
          </div>
          <div>
            <p></p>
            <p>
            We are enabling inbound calls.
            This may take some time.
            </p>
          </div>
          </div>

        </Modal.Content>

    </Modal>






  )

}

export default InboundCallingEnableModal